export default __webpack_public_path__ + "static/media/odvz_depto_con-pol_color.f4c81b24.png";